var _rect, _path, _path2, _rect2, _path3, _path4, _circle, _path5, _path6, _path7, _rect3, _path8, _path9, _path10, _path11, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 256 256",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#cecece",
    height: 151.106,
    rx: 13.665,
    width: 219.26,
    x: 18.37,
    y: 24.254
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.37 161.695v-123.777a13.681 13.681 0 0 1 13.665-13.664h-10a13.681 13.681 0 0 0 -13.665 13.664v123.777a13.681 13.681 0 0 0 13.665 13.665h10a13.681 13.681 0 0 1 -13.665-13.665z",
    fill: "#afafaf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m227.63 161.695v-123.777a13.681 13.681 0 0 0 -13.665-13.665h10a13.681 13.681 0 0 1 13.665 13.665v123.777a13.681 13.681 0 0 1 -13.665 13.665h-10a13.681 13.681 0 0 0 13.665-13.665z",
    fill: "#e2e2e2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#63bce7",
    height: 122.288,
    rx: 5.256,
    width: 202.442,
    x: 26.779,
    y: 32.662
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.779 149.695v-111.777a5.271 5.271 0 0 1 5.256-5.256h-10a5.271 5.271 0 0 0 -5.256 5.256v111.777a5.271 5.271 0 0 0 5.256 5.256h10a5.271 5.271 0 0 1 -5.256-5.256z",
    fill: "#6377e7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m219.221 149.695v-111.777a5.271 5.271 0 0 0 -5.256-5.256h10a5.271 5.271 0 0 1 5.256 5.256v111.777a5.271 5.271 0 0 1 -5.256 5.256h-10a5.271 5.271 0 0 0 5.256-5.256z",
    fill: "#63e2e7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 147.199,
    fill: "#9e9e9e",
    r: 39.978
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m98.022 147.2a39.976 39.976 0 0 1 34.978-39.657 39.978 39.978 0 1 0 0 79.311 39.976 39.976 0 0 1 -34.978-39.654z",
    fill: "#707070"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m109.249 187.176h37.5a44.65 44.65 0 0 1 44.65 44.65 0 0 0 0 1 0 0h-126.799a0 0 0 0 1 0 0 44.65 44.65 0 0 1 44.649-44.65z",
    fill: "#f8af23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m119.249 187.176h-10a44.649 44.649 0 0 0 -44.649 44.65h10a44.649 44.649 0 0 1 44.649-44.65z",
    fill: "#f87023"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#f46275",
    height: 85.951,
    rx: 10,
    width: 155,
    x: 50.5,
    y: 13.201
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m60.5 89.152v-65.952a10 10 0 0 1 10-10h-10a10 10 0 0 0 -10 10v65.952a10 10 0 0 0 10 10h10a10 10 0 0 1 -10-10z",
    fill: "#f43075"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m195.5 89.152v-65.952a10 10 0 0 0 -10-10h10a10 10 0 0 1 10 10v65.952a10 10 0 0 1 -10 10h-10a10 10 0 0 0 10-10z",
    fill: "#f48875"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m85.721 36.128h10.167a3.4 3.4 0 0 1 2.507 1.1l15.368 16.725a3.4 3.4 0 0 1 -.01 4.618l-15.359 16.565a3.4 3.4 0 0 1 -2.5 1.09h-10.125a3.4 3.4 0 0 1 -2.5-5.719l11.07-11.935a3.4 3.4 0 0 0 .01-4.618l-11.135-12.118a3.4 3.4 0 0 1 2.507-5.708z",
    fill: "#f8af23"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m173.69 68.65a7.575 7.575 0 0 1 -7.575 7.575h-41a7.575 7.575 0 0 1 -7.575-7.575 7.575 7.575 0 0 1 7.575-7.575h41a7.575 7.575 0 0 1 7.575 7.575z",
    fill: "#f8af23"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#3f3679"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m27.323 241.3h-18a1.5 1.5 0 1 0 0 3h18a1.5 1.5 0 1 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.68 241.3h-18a1.5 1.5 0 0 0 0 3h18a1.5 1.5 0 0 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.479 241.3h-180.958a1.5 1.5 0 0 0 0 3h180.958a1.5 1.5 0 0 0 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.32 233.326h237.36a1.5 1.5 0 0 0 0-3h-53.818a46.2 46.2 0 0 0 -46.111-44.65h-3.291a41.59 41.59 0 0 0 13.494-8.817h67.012a15.182 15.182 0 0 0 15.165-15.165v-123.776a15.182 15.182 0 0 0 -15.165-15.165h-16.989a11.5 11.5 0 0 0 -11.477-11.053h-135a11.5 11.5 0 0 0 -11.477 11.053h-16.988a15.182 15.182 0 0 0 -15.165 15.165v123.777a15.182 15.182 0 0 0 15.165 15.165h67.012a41.59 41.59 0 0 0 13.494 8.817h-3.291a46.2 46.2 0 0 0 -46.111 44.65h-53.819a1.5 1.5 0 1 0 0 3zm226.81-195.408v123.777a12.178 12.178 0 0 1 -12.165 12.165h-64.224a41.367 41.367 0 0 0 8.684-17.409h55.54a6.763 6.763 0 0 0 6.756-6.755v-111.778a6.763 6.763 0 0 0 -6.756-6.755h-16.965v-5.41h16.965a12.179 12.179 0 0 1 12.165 12.165zm-149.608 109.282a41.627 41.627 0 0 0 .472 6.251h-54.959a3.76 3.76 0 0 1 -3.756-3.755v-111.778a3.76 3.76 0 0 1 3.756-3.755h16.965v54.99a11.513 11.513 0 0 0 11.5 11.5h135a11.513 11.513 0 0 0 11.5-11.5v-54.99h16.965a3.76 3.76 0 0 1 3.756 3.755v111.777a3.76 3.76 0 0 1 -3.756 3.755h-54.959a41.479 41.479 0 1 0 -82.484-6.25zm-34.522-124a8.51 8.51 0 0 1 8.5-8.5h135a8.51 8.51 0 0 1 8.5 8.5v65.952a8.51 8.51 0 0 1 -8.5 8.5h-135a8.51 8.51 0 0 1 -8.5-8.5zm-32.13 138.495v-123.777a12.179 12.179 0 0 1 12.165-12.165h16.965v5.409h-16.965a6.763 6.763 0 0 0 -6.756 6.755v111.778a6.763 6.763 0 0 0 6.756 6.755h55.54a41.367 41.367 0 0 0 8.684 17.409h-64.224a12.178 12.178 0 0 1 -12.165-12.164zm69.652-14.5a38.478 38.478 0 1 1 38.478 38.481 38.522 38.522 0 0 1 -38.478-38.476zm19.728 41.478h37.5a43.2 43.2 0 0 1 43.124 41.65h-123.748a43.2 43.2 0 0 1 43.124-41.647z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m93.245 54.969a1.914 1.914 0 0 1 -.006 2.583l-11.066 11.934a4.9 4.9 0 0 0 3.6 8.239h10.127a4.92 4.92 0 0 0 3.6-1.569l15.359-16.564a4.931 4.931 0 0 0 .015-6.653l-15.374-16.725a4.915 4.915 0 0 0 -3.611-1.586h-10.168a4.9 4.9 0 0 0 -3.611 8.223zm-9.268-16.2a1.858 1.858 0 0 1 1.744-1.139h10.167a1.909 1.909 0 0 1 1.4.616l15.369 16.725a1.914 1.914 0 0 1 -.006 2.583l-15.358 16.562a1.91 1.91 0 0 1 -1.4.609h-10.124a1.9 1.9 0 0 1 -1.4-3.2l11.07-11.933a4.931 4.931 0 0 0 .015-6.653l-11.135-12.119a1.857 1.857 0 0 1 -.342-2.053z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m125.111 77.725h41a9.075 9.075 0 1 0 0-18.15h-41a9.075 9.075 0 1 0 0 18.15zm0-15.15h41a6.075 6.075 0 1 1 0 12.15h-41a6.075 6.075 0 1 1 0-12.15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService01);
export default __webpack_public_path__ + "static/media/service01.a7c55a902f8b6bac3b1f43768db0f86d.svg";
export { ForwardRef as ReactComponent };